import { HighlightedAppLocationViewCounts } from "../api/faq/getHighlightedAppLocationViews";
import { HighlightedFaqViewCounts } from "../api/faq/getHighlightedFaqViews";
import { AppLocationRenderFunction } from "../helpers/faq";

export type CRMAppLocationIdentifier =
  | "QuoteView-$CostPerPeriod-TopPinkBox"
  | "QuoteView-Annualkms-Details"
  | "QuoteView-PurchaseType-Details"
  | "QuoteView-AnnualSalary-Details"
  | "QuoteView-BelowLifeofLeaseSavings"
  | "QuoteView-BusinessUsage%-Details"
  | "QuoteView-ComprehensiveInsurance-Includes"
  | "QuoteView-Finance-Includes"
  | "QuoteView-Fuel/Charging-Includes"
  | "QuoteView-GST-Includes"
  | "QuoteView-Includes$offinance&runningCostpa-Pinkbox"
  | "QuoteView-LeaseTerm-Details"
  | "QuoteView-LifeofLeaseSavings-BottomPage"
  | "QuoteView-LuxuryCarCharge-Includes"
  | "QuoteView-ManagementFee-Includes"
  | "QuoteView-NetCost-BottomPage"
  | "QuoteView-OnroadCost-Details"
  | "QuoteView-PackageValue"
  | "QuoteView-Rego&CTP-Includes"
  | "QuoteView-ResidualIncGST-Details"
  | "QuoteView-Saving%"
  | "QuoteView-Savings-Year-BottomPage"
  | "QuoteView-Servicing-Includes"
  | "QuoteView-Tyres-Includes"
  | "QuoteView-All"
  | "QuoteView-AIVehicleSuggestion"
  | "QuoteView-VehicleName"
  | "QuoteView-NewQuoteButton"
  | "QuoteView-NameQuoteInput"
  | "QuoteView-AIVehicleSuggestionControl"
  | "QuoteView-ChooseCar"
  | "QuoteView-AIVehicleReview"
  | "QuoteView-InvalidCalculations"
  | "QuoteEdit-AIVehicleSuggestion"
  | "QuoteList-StatusCurrentStage"
  | "QuoteList-SortOrder"
  | "AIVehicleSuggestion-Page"
  | "AIVehicleSuggestion-PoweredBy"
  | "ExpenseClaimsView-PendingClaims"
  | "ExpenseClaimsView-AvailForClaims"
  | "ExpenseClaimsView-WhatCanIClaim"
  | "ExpenseClaimsView-WhatIsTheETA"
  | "ExpenseClaimsInput-PendingClaims"
  | "ExpenseClaimsInput-AvailForClaims"
  | "ExpenseClaimsInput-WhatCanIClaim"
  | "ExpenseClaimsSubmit-Declaration"
  | "ActivatedDossierHome-RunningCostGST"
  | "ActivatedDossierHome-IncomeTaxSaved"
  | "ActivatedDossierHome-TotalSavings"
  | "ActivatedDossierHome-FAQList"
  | "DossierBudget-Page"
  | "DossierBudget-BudgetCategory"
  | "DossierBudget-AvailableBudget"
  | "ContactActivated-FAQList"
  | "QuoteCompareView-AnnualKm"
  | "QuoteCompareView-Residual"
  | "QuoteCompareView-WeeklyNetCost"
  | "QuoteCompareView-AnnualSavings"
  | "QuoteCompareView-SavingsPct"
  | "QuoteCompareView-VehicleInfo"
  | "QuoteCompareView-Onroad"
  | "QuoteCompareView-Term"
  | "QuoteCompareView-BusinessUsagePct"
  | "FinCompareView-Info"
  | "FinCompareView-UpfrontCost"
  | "FinCompareView-AnnTaxSavings"
  | "FinCompareView-SavingsPct"
  | "FinCompareView-InterestRateFAQ"
  | "FinCompareView-LifetimeCostNovated"
  | "FinCompareView-LifetimeCostCash"
  | "FinCompareView-LifetimeCostHomeLoan"
  | "FinCompareView-LifetimeCostCarFinance"
  | "FinCompareView-InterestRateNovated"
  | "FinCompareView-InterestRateCash"
  | "FinCompareView-InterestRateHomeLoan"
  | "FinCompareView-InterestRateCarLoan"
  | "DossierTransaction-WhatIsETA"
  | "CurrentBalance-Page"
  | "CurrentBalance-Fuel"
  | "CurrentBalance-Service"
  | "CurrentBalance-Tyres"
  | "CurrentBalance-Insurance"
  | "CurrentBalance-Rego"
  | "CurrentBalance-Fee"
  | "CurrentBalance-Finance"
  | "CurrentBalance-Balance"
  | "VehicleSearch-Page"
  | "VehicleSearch-VehicleCount"
  | "VehicleSearchList-Page"
  | "VehicleCompare-Page"
  | "VehicleCompare-PoweredByAI"
  | "VehicleCompare-VehiclePrice"
  | "VehicleCompare-Value"
  | "VehicleCompare-Comfort"
  | "VehicleCompare-Performance"
  | "VehicleCompare-RunningCost"
  | "VehicleCompare-Summary"
  | "VehicleCompare-Specs"
  | "VehicleCompare-AIReview"
  | "VehicleCompare-AIVehicleSuggestion"
  | "VehicleCompare-InitialValueRating"
  | "AIVehicleReview-Page"
  | "AIVehicleReview-PoweredByAI"
  | "AIVehicleReview-ValueReview"
  | "AIVehicleReview-ComfortReview"
  | "AIVehicleReview-PerformanceReview"
  | "AIVehicleReview-RunningCostReview"
  | "AIVehicleReview-Review"
  | "AIVehicleReview-AIVehicleSuggestions"
  | "VehicleSpec-Page"
  | "VehicleSpec-AIVehicleSuggestions"
  | "VehicleSpec-AIVehicleReview"
  | "SelectVehicleSourcing-Page"
  | "SelectVehicleSourcing-LimitVehiclePricing"
  | "SelectVehicleSourcing-FAQList"
  | "SelectVehicleToSource-Page"
  | "SelectVehicleToSource-NewQuotesOnlyNote"
  | "ConfirmVehicleToSource-SelectVehicleText"
  | "SelectAutoUXOptionsToSource-Page"
  | "SelectAutoUXOptionsToSource-ChangeLaterText"
  | "SelectManufacturerOptionsToSource-Page"
  | "SelectManufacturerOptionsToSource-SelectCorrectOptionsText"
  | "ConfirmVehicleOptionsToSource-Page"
  | "ConfirmVehicleOptionsToSource-ChangeLaterText"
  | "ConfirmVehicleOptionsToSource-SelectCorrectOptionsText"
  | "CorpSupportNeedHelp-FAQList"
  | "EmployerRequestClose-Page"
  | "EmployerRequestClose-FAQList"
  | "EmployerClose-Page"
  | "EmployerClose-FAQList"
  | "EmployerClose-EndDate"
  | "DriverRequestClose-Page"
  | "DriverRequestClose-FAQList"
  | "DriverClose-Page"
  | "DriverClose-FAQList"
  | "DriverClose-EndDate"
  | "DriverClose-CurrentBalance"
  | "DriverClose-TransactionsToBeLoaded"
  | "DriverClose-ProjectedBalance"
  | "DriverClose-NextFinancePaymentDue"
  | "DriverClose-LastDateInsuranceCover"
  | "EmployerHome-PayrollTaxSavingsCalculation"
  | "LifetimePayrollTaxSavings-PayrollTaxSavingsCalculation";

export const quoteViewIncludeAppLocationIdentifiers: CRMAppLocationIdentifier[] =
  [
    "QuoteView-ComprehensiveInsurance-Includes",
    "QuoteView-Finance-Includes",
    "QuoteView-Fuel/Charging-Includes",
    "QuoteView-GST-Includes",
    "QuoteView-LuxuryCarCharge-Includes",
    "QuoteView-ManagementFee-Includes",
    "QuoteView-Rego&CTP-Includes",
    "QuoteView-Servicing-Includes",
    "QuoteView-Tyres-Includes",
  ];

export const quoteViewDetailsAppLocationIdentifiers: CRMAppLocationIdentifier[] =
  [
    "QuoteView-Annualkms-Details",
    "QuoteView-PurchaseType-Details",
    "QuoteView-AnnualSalary-Details",
    "QuoteView-BusinessUsage%-Details",
    "QuoteView-LeaseTerm-Details",
    "QuoteView-OnroadCost-Details",
    "QuoteView-ResidualIncGST-Details",
  ];

export type APPage =
  | "initial-user-info"
  | "quote-edit"
  | "vehicle-options"
  | "quote-view"
  | "dossier-list"
  | "dossier-view"
  | "request-employer-setup-authorised"
  | "request-employer-setup-not-authorised"
  | "driver-pa"
  | "driver-bank"
  | "employer-home"
  | "employer-approve-drivers"
  | "vehicle-suggestions"
  | "expense-claims-view"
  | "expense-claim-create"
  | "dossier-transactions-view"
  | "dossier-activated-view"
  | "dossier-budgets-view"
  | "help-activated-dossier"
  | "quote-compare-view"
  | "finance-compare-view"
  | "dossier-balances-view"
  | "vehicle-search-input"
  | "vehicle-search-results"
  | "vehicle-details"
  | "vehicle-compare-view"
  | "vehicle-review"
  | "select-vehicle-sourcing"
  | "select-vehicle-to-source"
  | "confirm-vehicle-to-source"
  | "select-auto-ux-options-to-source"
  | "select-manufacturer-options-to-source"
  | "confirm-vehicle-options-to-source"
  | "help-corporate-support"
  | "employer-request-lease-closure"
  | "employer-lease-closure"
  | "driver-request-lease-closure"
  | "driver-lease-closure"
  | "employer-lifetime-payroll-tax-savings";

export type APFaqVoteType = "useful" | "not-useful";

type HighlightedFaq = {
  id: string;
  question: string;
  faqApplocationId: string | null;
};

export type FaqAppLocation = {
  id: string;
  appLocationIdentifier: CRMAppLocationIdentifier;
  name: string;
  page: APPage;
  faqCount: number;
  highlightedFaq: HighlightedFaq | null;
  highlightedText: string | null;
};

export type Faq = {
  id: string;
  faqApplocationId: string | null;
  question: string;
  answer: string;
  answerBelowImage: string | null;
  imageUrl: string | null;
  usefulCount: number;
  notUsefulCount: number;
  viewCount: number;
  isHighlighted: boolean;
};

export type FaqVote = {
  id: string;
  faqId: string;
  vote: APFaqVoteType;
};

export interface FaqProps {
  renderAppLocation: AppLocationRenderFunction;
  faqAppLocations: FaqAppLocation[];
  highlightedFaqViews: HighlightedFaqViewCounts;
  highlightedAppLocationViews: HighlightedAppLocationViewCounts;
  carouselAppLocationId?: string | null;
  carouselFaqs?: Faq[];
}
